import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ShareOfVoiceSettingsStateType, defaultSettings } from "./ShareOfVoiceSettings";
import TitleCase from "components/formatting/TitleCase";
import ISOPercentage from "components/formatting/ISOPercentage";
import ISONumber from "components/formatting/ISONumber";

interface ShareOfVoicePreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: ShareOfVoiceSettingsStateType | {};
}

export default function ShareOfVoicePreview(props: ShareOfVoicePreviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const windowHeight = window.innerHeight;
  const chartColors = theme.colors.namedColors.chartColorArray;
  const currentState = {...defaultSettings, ...props.settingsState};

  const dummyData = [
    { label: 'Query 1', percent: .90, value: 100, color: chartColors[0] },
    { label: 'Query 2', percent: .70, value: 70, color: chartColors[0] },
    { label: 'Query 3', percent: .75, value: 75, color: chartColors[0] },
    { label: 'Query 4', percent: .45, value: 45, color: chartColors[0] },
    { label: 'Query 5', percent: .50, value: 50, color: chartColors[0] },
    { label: 'Query 6', percent: .15, value: 15, color: chartColors[0] },
    { label: 'Query 7', percent: .25, value: 25, color: chartColors[0] }
  ];

  if (currentState.sortValue === 'asc') {
    dummyData.sort((a, b) => a.percent - b.percent);
  } else if (currentState.sortValue === 'desc') {
    dummyData.sort((a, b) => b.percent - a.percent);
  }

  const dummyRows = dummyData.map((row) => {
    return (
      <Box key={row.label}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="subtitle2">
            <TitleCase text={row.label} />
          </Typography>
          <Box sx={{ ml: 1}}>
            {currentState.displayValue === "percent" && <ISOPercentage value={row.percent} />}
            {currentState.displayValue === "count" && <ISONumber number={row.value} />}
          </Box>
        </Box>
        <Box
          sx={{
            mb: 2,
            width: "100%",
            height: "25px",
            backgroundColor: theme.palette.grey[300]
          }}>
          <Box sx={{ width: `${row.percent * 100}%`, height: "100%", backgroundColor: row.color }} />  
        </Box>
      </Box>
    );
  })

  return (
    <Stack
      sx={{
        gap: 1,
        width: isSmallScreen ? "100%" : "50%",
        flex: 1,
        height: windowHeight < 600 ? "35vh" : "55vh"
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle} />
        </Typography>}
      <Box>{dummyRows}</Box>
    </Stack>
  );
}